import React from "react";

const DnevniceRSzaStampu = ({ podaci }) => {
  const {
    putniNalog = "",
    vozac = "",
    period = "",
    relacija = "",
    registracija = "",

    kretanja = [],
    troskovi = [],
    dnevnice = [],

    neOporeziviIznos = "0,00",
    oporeziviIznos = "0,00",
    iznosPoreza = "0,00",

    ukupnoDnevnica = "0,00",
    ukupnoTroskova = "0,00",
    ukupnoDnevnicaCount = "0",

    ukupnoZaIsplatuRSD = "",
    datumObracuna = ""
  } = podaci || {};

  const printStyles = `
    * { box-sizing: border-box; }
    html, body {
      max-height: fit-content;
      margin: 0;
      padding: 0;
      font-family: "Times New Roman", Arial, sans-serif;
      font-size: 18pt;
      color: #000;
    }

    @page {
      size: A4 portrait;
      margin: 5% 5% 5% 5%;
    }

    #wage-page {
      width: 100%;
    }

    .title-row {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 40px;
      font-size: 12pt;
      font-weight: bold;
    }
    .title-row span:first-child {
      margin-right: 6px;
    }

    .info-block {
      margin-bottom: 12px;
      font-size: 14px !important;
      line-height: 1.4;
    }
    .info-line {
      display: flex;
      gap: 4px;
    }
    .label {
      font-weight: normal;
    }
    .value-bold {
      font-weight: bold;
    }

    .dotted-line {
      border: none;
      border-top: 1px dotted #000;
      margin: 8px 0 4px 0;
    }

    table {
      margin: 0 5% 0 5% !important;
      width: 90% !important;
      border-collapse: collapse;
      font-size: 9pt;
    }

    .tbl-header th {
      border-bottom: 1px solid #000;
      padding: 2px 3px;
      height: 100%;
      font-size: 14px;
      text-align: center;
      font-weight: bold;
    }
    .tbl-body td {
      height: 100%;
      font-size: 14px !important;
      text-align: center;
      padding: 2px 3px;
    }

    .tbl-sati th:nth-child(1) { width: 10%; }
    .tbl-sati th:nth-child(2) { width: 30%; }
    .tbl-sati th:nth-child(3) { width: 30%; }
    .tbl-sati th:nth-child(4) { width: 30%; text-align: center; }
    .tbl-sati td:nth-child(4) { text-align: center; }

    .section-title {
      margin-top: 18px;
      font-weight: bold;
      font-size: 16px !important;
      text-transform: uppercase;
    }

    .tbl-troskovi th:nth-child(1) { width: 15%; }
    .tbl-troskovi th:nth-child(2) { width: 55%; }
    .tbl-troskovi th:nth-child(3) { width: 30%; text-align: center; }
    .tbl-troskovi td:nth-child(3) { text-align: center; }

    .troskovi-ukupno {
      margin-top: 8px;
      text-align: right;
       font-size: 16px !important;
      font-weight: bold;
      margin-right: 5% !important;
    }

    .tbl-dnevnice th:nth-child(1) { width: 15%; }
    .tbl-dnevnice th:nth-child(2) { width: 15%; text-align: center; }
    .tbl-dnevnice th:nth-child(3) { width: 25%; text-align: center; }
    .tbl-dnevnice th:nth-child(4) { width: 20%; text-align: center; }
    .tbl-dnevnice th:nth-child(5) { width: 25%; text-align: center; }

    .tbl-dnevnice td:nth-child(2),
    .tbl-dnevnice td:nth-child(3),
    .tbl-dnevnice td:nth-child(4),
    .tbl-dnevnice td:nth-child(5) {
      text-align: center;
    }

    .bottom-blocks {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .bottom-left {
      font-size: 9pt;
      line-height: 1.4;
    }
    .bottom-left-row {
      display: flex;
      justify-content: space-between;
      width: 180px;
    }

    .sum-box {
      border: 1px solid #000;
      padding: 6px 10px;
      width: 400px;
      font-size: 16px !important;
    }
    .sum-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2px;
    }
    .sum-row span:first-child {
      font-weight: bold;
    }
    .sum-row.dotted {
      border-bottom: 1px dotted #000;
      padding-bottom: 2px;
      margin-bottom: 4px;
    }

    .din-note {
      text-align: right;
      margin-top: 4px;
      font-size: 16px !important;
    }

    .obracun-podnet {
      margin-top: 26px;
      text-align: left;
      font-size: 9pt;
    }
    .obracun-podnet-line {
      margin-top: 5px;
      border-top: 1px solid #000;
      width: 120px;
    }

    .signatures {
      margin: 50px 5% 0 5% !important;
      display: flex;
      justify-content: space-between;
      font-size: 9pt;
    }
    .signature-col {
      width: 30%;
      text-align: center;
    }
    .signature-line {
      border-top: 1px solid #000;
      margin-bottom: 4px;
    }

    @media print {
      * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }
  `;

  return (
    <div id="wage-page">
      <style>{printStyles}</style>

      {/* Naslov */}
      <div className="title-row">
        <span>Obračun dnevnica i gotovninskih troškova u zemlji broj:</span>
        <span>{putniNalog}</span>
      </div>

      {/* Osnovni podaci */}
      <div className="info-block">
        <div className="info-line">
          <span className="label">Vozač:</span>&nbsp;
          <span className="value-bold">{vozac}</span>
        </div>
        <div className="info-line">
          <span className="label">Službeno putovanje obavljeno u periodu od:</span>&nbsp;
          <span className="value-bold">{period}</span>
        </div>
        <div className="info-line">
          <span className="label">Na relaciji:</span>&nbsp;
          <span className="value-bold">{relacija}</span>
        </div>
        <div className="info-line">
          <span className="label">Registarski broj kamiona:</span>&nbsp;
          <span className="value-bold">{registracija}</span>
        </div>
      </div>

      {/* Tabela sati */}
      <div className="section-title" style={{textDecoration: 'underline', marginBottom:'2%'}}>KRETANJE U ZEMLJI</div>

      <table className="tbl-sati">
        <thead className="tbl-header">
          <tr>
            <th>Datum i vreme odlaska</th>
            <th>Datum i vreme dolaska</th>
            <th>Sati</th>
          </tr>
        </thead>
        <tbody className="tbl-body">
          {kretanja.map((r, idx) => (
            <tr key={idx}>
              <td>{r.DatumOd}</td>
              <td>{r.DatumDo}</td>
              <td>{r.Sati}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="troskovi-ukupno">Broj dnevnica: <span>{ukupnoDnevnicaCount}</span></div>

      {/* TROŠKOVI */}
      <div className="section-title" style={{textDecoration: 'underline', marginBottom:'2%'}}>TROŠKOVI</div>

      <table className="tbl-troskovi">
        <thead className="tbl-header">
          <tr>
            <th>Trošak</th>
            <th>Iznos</th>
          </tr>
        </thead>
        <tbody className="tbl-body">
          {troskovi.map((t, idx) => (
            <tr key={idx}>
              <td>{t.Naziv}</td>
              <td>{t.Iznos}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="troskovi-ukupno">Ukupno: <span>{ukupnoTroskova}</span></div>

      {/* DNEVNICE */}
      {/* <div className="section-title" style={{textDecoration: 'underline', marginBottom:'2%'}}>DNEVNICE</div>

      <table className="tbl-dnevnice">
        <thead className="tbl-header">
          <tr>
            <th>Zemlja</th>
            <th>Dnevnica</th>
            <th>Iznos dnevnice</th>
            <th>Za isplatu</th>
            <th>Iznos zakonski</th>
          </tr>
        </thead>
        <tbody className="tbl-body">
          {dnevnice.map((d, idx) => (
            <tr key={idx}>
              <td>{d.Zemlja}</td>
              <td>{d.Dnevnica}</td>
              <td>{d.IznosDnevnice}</td>
              <td>{d.ZaIsplatu}</td>
              <td>{d.IznosZakonski}</td>
            </tr>
          ))}
        </tbody>
      </table> */}

      {/* Donji blokovi: iznosi + suma box */}
      <div className="bottom-blocks">
        <div className="bottom-left">
          <div className="bottom-left-row">
            <span>Neoporezivi iznos:</span>
            <span>{neOporeziviIznos}</span>
          </div>
          <div className="bottom-left-row">
            <span>Oporezivi iznos:</span>
            <span>{oporeziviIznos}</span>
          </div>
          <div className="bottom-left-row">
            <span>Iznos poreza:</span>
            <span>{iznosPoreza}</span>
          </div>
        </div>

        <div>
          <div className="sum-box">
            <div className="sum-row">
              <span>UKUPNO DNEVNICA:</span>
              <span>{ukupnoDnevnica}</span>
            </div>
            <div className="sum-row dotted">
              <span>UKUPNO TROŠKOVA:</span>
              <span>{ukupnoTroskova}</span>
            </div>
            <div className="sum-row">
              <span>UKUPNO ZA ISPLATU:</span>
              <span>{ukupnoZaIsplatuRSD} {putniNalog.includes("HR") || putniNalog.includes("SI") ? '(EUR)' : '(RSD)'}</span>
            </div>
          </div>
        </div>
      </div>

      {/* OBRAČUN PODNET + datum */}
      <div className="obracun-podnet">
        <div>OBRAČUN PODNET</div>
        <div style={{marginTop:'0.5%', maxWidth:'100px', display:'flex', justifyContent:'center', alignItems:'center'}}><strong>{datumObracuna}</strong></div>
        <div className="obracun-podnet-line"></div>
      </div>

      {/* Potpisi */}
      <div className="signatures">
        <div className="signature-col">
          <div className="signature-line"></div>
          <div>Potpis knjigovođe</div>
        </div>
        <div className="signature-col">
          <div className="signature-line"></div>
          <div>Potpis odgovornog lica</div>
        </div>
        <div className="signature-col">
          <div className="signature-line"></div>
          <div>{vozac || vozac}</div>
        </div>
      </div>
    </div>
  );
};

export default DnevniceRSzaStampu;
